'use strict';

function addTabsForSIComp ($element, data, dataLength) {
  var current;
  var innerHtml;
  var url;
  var visualUrl;
  var tabs = $('<div class="social-media-tabs comp-tabs"></div>');

  for (url in data) {
    current = data[url];
    visualUrl = current.url;
    innerHtml = '<span class="color"></span>' + visualUrl;

    if (url === window.currentWebsite) {
      tabs.prepend(
        '<span class="not-tab" title="' + visualUrl + '">' +
        innerHtml +
        '</span>'
      );
    } else {
      tabs.append(
        '<a class="tab no-advice-target" title="' + visualUrl + '">' +
        innerHtml +
        '</a>'
      );
    }
  }
  return $element.after(tabs);
}

module.exports = addTabsForSIComp;
